<div class="login-container container mat-tertiary"
     fxLayout="column"
     fxLayoutGap="16px">

    <div class="login-page-container"
         fxFlex="grow"
         fxLayout="column"
         fxLayoutAlign="start center">
        <div class="login mat-elevation-z4 container mat-secondary primary-border border-full">
            <br>
            <h3>
                You have been Logged out of FreshDesk.
            </h3>
            <br>
        </div>
    </div>
</div>
